import { useDispatch, useSelector } from "react-redux";
import { SARSHeader, ErrorModal } from "@soqs/common";
import { useEffect } from "react";
import {
  captchaSubmissionStarted,
  captchaSuccessful,
  captureDetailsErrors,
  clearCaptureDetailsErrors,
  isAgent,
  validateUserSession,
} from "./features/CaptureDetailsSlice";
import CaptureDetails from "./Components/CaptureDetails/CaptureDetails";
import {
  bookingErrors,
  cancelBooking,
  clearBookingErrors,
  detailsSubmissionStarted,
  detailsSubmitted,
} from "./features/BookingsSlice";
import Landing from "./Components/ViewBookings/Landing";
import { getErrorModalInnerHTML, getErrorModalTitle } from "./features/Helper";
import { ErrorResponse } from "./models/ErrorResponse";
import { Backdrop, CircularProgress, Typography } from "@mui/material";

const ErrorDisplay = (errorState: ErrorResponse | null) => {
  return Array.isArray(errorState?.error) ? (
    <ul>
      {errorState?.error.map((e) => (
        <li key={e}>{e.replace("- ", "")}</li>
      ))}
    </ul>
  ) : (
    <p
      dangerouslySetInnerHTML={{
        __html: getErrorModalInnerHTML(errorState),
      }}
    ></p>
  );
};

function App() {
  const dispatch = useDispatch();
  const detailsSubmittedValue = useSelector(detailsSubmitted);
  const captureDetailsSuccessful = useSelector(captchaSuccessful);
  const bookingErrorState = useSelector(bookingErrors);
  const captureDetailsErrorState = useSelector(captureDetailsErrors);
  const hasDetailsSubmissionStarted = useSelector(detailsSubmissionStarted);
  const hasCaptchaSubmissionStarted = useSelector(captchaSubmissionStarted);
  const agent = useSelector(isAgent);
  // prettier-ignore

  useEffect(() => {
    window.addEventListener("load", () => {
      sessionStorage.setItem("token", '');
      dispatch(validateUserSession());
    });

    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, [dispatch]);

  return (
    <>
      <SARSHeader
        onLogoClick={() => dispatch(cancelBooking(null))}
        pageTitle="eBooking"
      />

      <div className="App">
        {detailsSubmittedValue && (captureDetailsSuccessful || agent) ? (
          <Landing />
        ) : (
          <CaptureDetails />
        )}

        <ErrorModal
          title={getErrorModalTitle(bookingErrorState)}
          open={bookingErrorState !== null && bookingErrorState.error !== null}
          onClose={() => {
            const errorState = bookingErrorState;
            console.error(errorState);
            dispatch(clearBookingErrors(null));
          }}
          subheader={ErrorDisplay(bookingErrorState)}
        />

        <ErrorModal
          title={getErrorModalTitle(captureDetailsErrorState)}
          open={
            captureDetailsErrorState !== null &&
            captureDetailsErrorState.error !== null
          }
          onClose={() => {
            const errorState = captureDetailsErrorState;
            console.error(errorState);
            dispatch(clearCaptureDetailsErrors(null));
          }}
          subheader={ErrorDisplay(captureDetailsErrorState)}
        />
      </div>

      <Backdrop
        sx={{ color: '#fff', zIndex: 200, flexDirection: 'column' }}
        open={(hasDetailsSubmissionStarted || hasCaptchaSubmissionStarted) && (bookingErrorState === null || bookingErrorState.error === null) && (captureDetailsErrorState=== null || captureDetailsErrorState.error === null)}
      >
        <CircularProgress color="inherit" size="4rem" thickness={4} />
        <Typography color="white" sx={{ mt: '1rem', fontSize: '18px' }}>Submitting ...</Typography>
      </Backdrop>
    </>
  );
}

export default App;
